const API_KEY = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1c2VyTmFtZSI6ImVkaWwiLCJtb2R1bGVJZCI6LTEsImF1dGhvcml0aWVzIjpbIkFETUlOIl19.soDQ6P7eQjGxRe4yHdvzTv_73Xo1QUMoKhNcflATEFwp95tzgVa4XZFkKVfV3s-aOUG58ucOUfOJI3mQtlU8aw"
const SEARCH_API_KEY = "Module Test_Module:Test_Module_Key"
const API_LOCATION = 'https://registry-api-swis2.trade.kg/'

export {API_KEY, SEARCH_API_KEY, API_LOCATION}
